import React from "react"
import SiteContext from "../../context/site-context"
import { GetMenuItems, GetMenuTypePath } from "../../lib/site-functions"
import { getInfoPage } from "../../lib/call-api"
import { Link } from "gatsby"

import './mainPageContent.scss'

export default function MainPageContent() {
  const { loadingSetState, menuItemsState } = React.useContext(SiteContext)

  const [pagesState, pagesSetState] = React.useState([])

  const myRef = React.useRef(null)
  const offsetY = myRef.current?.getBoundingClientRect().y

  const [inView, setInView] = React.useState(() => {
    return false
  })

  React.useEffect(() => {
    if (inView === false) {
      if (offsetY < 350) {
        setInView(true)
      }
    }
  }, [offsetY])

  React.useEffect(() => {
    const companyItems = menuItemsState.companies.filter(
      item => item.showOnMainPage === true
    )
    const serviceItems = menuItemsState.services.filter(
      item => item.showOnMainPage === true
    )
    const otherItems = menuItemsState.others.filter(
      item => item.showOnMainPage === true
    )

    const pagesItems = [...companyItems, ...serviceItems, ...otherItems]
    let findMenu

    pagesItems.map(item => {
      findMenu = GetMenuItems(menuItemsState, item.menuType, item.slug)
      if (findMenu.length > 0) {
        getInfoPage(findMenu[0].id).then(responce => {
          // console.log('MainPageContent responce.data[0].preview', responce.data[0].preview);
          if (responce.data.length > 0) {
            item.content = responce.data[0].preview
            pagesSetState(prev => {
              return [...prev, item]
            })

            loadingSetState(prevValues => (
              { ...prevValues, mainPageLoaded: true }
            ))
          }
        })
      }
      return null
    })

    //pagesSetState(pagesItems)
  }, [menuItemsState.loadedTime])

  return (
    // style={{ minHeight: "790px" }}
    <div ref={myRef} className="about-section" >
      {/* <div className="container">
        {pagesState.map(item => (
          <div key={item.id} className="inner visible text-center">
            <div className="push20" />


                <h1>{item.title}</h1>
                <main className="content">
                  <div className={
                    "flex " + (inView ? "visible animated fadeIn" : "")
                  }
                  >
                    <div>
                      <img
                        src={item.icon}
                        //style={{ maxHeight: 500, width: "auto" }}
                        alt="Фотография"
                      />
                    </div>
                    <div>
                      <p
                        className="text-justify"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    </div>

                  </div>

                  <div className="push20" />
                </main>
                <p>
                  <Link
                    to={
                      "/infopages/" +
                      GetMenuTypePath(item.menuType) +
                      "/" +
                      item.slug
                    }
                    className="btn invert"
                  >
                    {item.title}
                  </Link>
                </p>


            <div className="push20" />
          </div>
        ))}
      </div> */}
    </div>
  )
}
